<template>
  <!-- 商品组件 -->
  <div class="products-list flex justify-start align-center flex-wrap">
    <div class="products-item" v-for="(item,index) in productForm.productList" :key="index">
      <i
        v-if="enterType!=='readonly'"
        class="el-icon-error"
        @click="deleteItem(index,productForm.productList)"
      ></i>
      <div class="goods-name">{{item.goodsnamec}}</div>
      <div
        class="goods-number"
        :title="item[`product.${index}.number`]!==undefined&&!item[`product.${index}.number`]?'error':null"
      >
        <el-input-number
          :class="item[`product.${index}.number`]!==undefined&&!item[`product.${index}.number`]?'error':null"
          size="mini"
          v-model="item.piece"
          :disabled="enterType==='readonly'"
        ></el-input-number>
        <div
          v-if="!item[`product.${index}.number`]"
          class="error-text"
          :title="item[`product.${index}.number.errorText`]"
        >{{item[`product.${index}.number.errorText`]}}</div>
      </div>
      <div class="goods-price">
        <span>
          <i class="star">*</i>
          货值
        </span>
        <el-input
          size="mini"
          :disabled="enterType==='readonly'"
          v-model="item.price"
          :class="item[`product.${index}.price`]!==undefined&&!item[`product.${index}.price`]?'error':null"
        ></el-input>
        <div
          v-if="!item[`product.${index}.price`]"
          class="error-text"
          :title="item[`product.${index}.price.errorText`]"
        >{{item[`product.${index}.price.errorText`]}}</div>
      </div>
    </div>
    <div
      class="products-item blue flex justify-center align-center"
      @click="add"
      v-if="enterType!=='readonly'"
    >
      <div>
        <div style="text-align:center;margin-bottom:2px">
          <el-button type="primary" icon="el-icon-plus" circle></el-button>
        </div>
        <div>添加商品</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enterType: {
      type: String,
      default: 'edit'
    },
    productList: {
      type: Array,
      default: () => {
        return []
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      productRules: {},
      validatorCallBackState: true
    }
  },
  computed: {
    productForm: {
      get () {
        return {
          productList: this.productList
        }
      },
      set (data) {
        return data
      }
    },
    tableRules () {
      if (this.productForm.productList.length > 0) {
        this.productForm.productList.forEach((item, key) => {
          if (item.prop !== undefined && item.prop.length > 0) {
            item.prop.forEach(k => {
              if (this.rules[k] !== undefined) { // 有prop校验属性
                if (this.rules[k].validator !== undefined && this.rules[k].required) { // 有validator自定义校验方法和必填时
                  this.productRules[`product.${key}.${k}`] = JSON.parse(JSON.stringify(this.rules[k]))
                  this.productRules[`product.${key}.${k}`].validator = this.rules[k].validator
                } else {
                  this.productRules[`product.${key}.${k}`] = JSON.parse(JSON.stringify(this.rules[k]))
                }
              }
            })
          }
        })
      }
      return this.productRules
    }
  },
  watch: {
    'productForm.productList': {
      handler (newValue, oldValue) {
        this.$emit('boxUpdata', newValue)
      },
      deep: true
    }
  },
  created () {

  },
  methods: {
    deleteItem (index, list) {
      console.log(list)
      list.splice(index, 1)
    },
    add () {
      this.$emit('add')
    },
    submit () { // productItem 校验
      let list = []
      let flag = true
      if (JSON.stringify(this.tableRules) !== '{}') {
        for (let i = 0; i < this.productForm.productList.length; i++) {
          const item = this.productForm.productList[i]
          const key = i
          if (item.prop !== undefined && item.prop.length > 0) {
            for (let j = 0; j < item.prop.length; j++) {
              const prop = item.prop[j]
              if (this.rules[prop] !== undefined) {
                if (this.tableRules[`product.${key}.${prop}`] !== undefined && this.tableRules[`product.${key}.${prop}`].required) { // 必须校验
                  if (this.tableRules[`product.${key}.${prop}`].validator !== undefined) { // 自定义规则校验
                    let tips = ''
                    this.tableRules[`product.${key}.${prop}`].validator({}, item[prop], (res) => {
                      tips = res
                      if (res) {
                        flag = false
                      } else {
                        flag = true
                      }
                    })
                    if (!flag && tips) {
                      this.$message({
                        message: tips,
                        type: 'warning'
                      })
                      return
                    }
                  } else {
                    if (!item[prop]) {
                      this.$message({
                        message: this.tableRules[`product.${key}.${prop}`].message,
                        type: 'warning'
                      })
                      return
                    }
                  }
                }

                if (item[`product.${key}.${prop}`] !== undefined && !item[`product.${key}.${prop}`]) { // 最终校验结果
                  flag = false
                }
              }
            }
          }
        }
      }

      if (flag) {
        if (this.productForm.productList.length > 0) {
          list = this.productForm.productList.map((item, key) => {
            const obj = {
              ...item
            }
            Object.keys(obj).forEach(k => {
              if (k.includes('product.') || k.includes('.name')) {
                delete obj[k]
              }
            })
            delete obj.prop

            return obj
          })
        }
        return list
      } else {
        return flag
      }
    }

  }
}
</script>

<style scoped >
.products-list {
  margin-top: 8px;
}
.products-list .products-item {
  box-sizing: border-box;
  width: 130px;
  height: 130px;
  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  cursor: pointer;
}
.products-item.blue {
  border: 1px solid rgb(64, 158, 255);
  background: rgb(236, 245, 255);
  color: rgb(64, 158, 255);
}

.products-item .el-icon-error {
  display: none;
  position: absolute;
  right: 1px;
  top: 0px;
  font-size: 20px;
}
.products-item:hover > i.el-icon-error {
  display: block;
}
.products-item i.el-icon-error:hover {
  color: brown;
}
.products-item .error-text {
  color: red;
  font-size: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.products-item .goods-name {
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 30px;
  line-height: 33px;
  width: 100%;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  font-size: 13px;
  margin-bottom: 15px;
}

.products-item .goods-number {
  box-sizing: border-box;
  padding: 0 4px;
  padding-bottom: 15px;
  position: relative;
}
.goods-number .el-input-number {
  width: 100%;
  border-radius: 14px;
}
.goods-number >>> .el-input-number > span.el-input-number__decrease,
.goods-number >>> .el-input-number > span.el-input-number__increase {
  width: 16px;
  height: 16px;
  line-height: 16px;
  top: calc(50% - 8px);
  background: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  color: #9fa1a7;
}
.goods-number >>> .el-input-number > span.el-input-number__decrease {
  margin-left: 5px;
}
.goods-number >>> .el-input-number > span.el-input-number__increase {
  margin-right: 5px;
}
.goods-number >>> .el-input__inner {
  border-radius: 20px;
  padding-left: 26px;
  padding-right: 26px;
  height: 24px;
  font-size: 14px;
}
.goods-price {
  position: relative;
  padding-bottom: 15px;
}
.goods-price >>> .el-input {
  box-sizing: border-box;
  width: 100%;
  padding: 0 4px;
}
.goods-price >>> .el-input .el-input__inner {
  border-radius: 20px !important;
  height: 24px;
  font-size: 14px;
  text-align: left;
  padding-left: 40px;
  padding-right: 10px;
}
.goods-price > span {
  position: absolute;
  top: 4px;
  left: 6px;
  z-index: 10;
  font-size: 12px;
  padding-left: 10px;
  color: #c0c4cc;
}
.goods-price > span > .star {
  color: red;
  position: absolute;
  top: 0px;
  left: 0;
}
.goods-price >>> .el-input.error .el-input__inner,
.goods-number >>> .el-input-number.error .el-input__inner {
  border-color: red;
}
.goods-price .error-text {
  font-size: 12px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/mainOrders/components/product.vue